import icon from "../../assets/icon.png";
import "./Launch.css";
import Footer from "../Footer";
import Header from "../Header";
import PageTransition from "../../PageTransition";
import { Helmet } from "react-helmet-async";

export default function ContentLaunch() {
  return (
    <>

          <Helmet>
        <title>Contact 2 Light Years | Start Your Project Today</title>

        <meta 
          name="description" 
          content="Get in touch with 2 Light Years to start your next high-performance website project. Let’s discuss UX, speed, and conversion optimization." 
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://www.2lightyears.com/launch" />

        {/* Open Graph */}
        <meta property="og:title" content="Contact 2 Light Years" />
        <meta property="og:description" content="Start your project with our UX and web performance experts." />
        <meta property="og:url" content="https://www.2lightyears.com/launch" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact 2 Light Years" />
        <meta name="twitter:description" content="Let’s build a high-performing website together." />
      </Helmet>

      <Header visible mode="normal" />
                 <PageTransition>

      <section className="launch-container container-fluid">
        <div className="row align-items-center launch-row">
          
          {/* LEFT */}
          <div className="col-lg-4 launch-left">
            <h1 className="launch-title">
              <div className="launch-line">
                LET&apos;S <img src={icon} alt="icon" />
              </div>

              <p className="launch-line">GET IN</p>

              <span className="launch-highlight">TOUCH</span>
            </h1>

            <div className="launch-graphic"></div>
          </div>

          {/* RIGHT */}
          <div className="col-lg-6 launch-right justify-content-center">
            <p className="launch-item">
              <i className="fa-solid fa-envelope"></i>
              <span>2lightyear.work@gmail.com</span>
            </p>

           

            <p className="launch-item address">
              <i className="fa-solid fa-location-arrow"></i>
              <span>
                First floor, 127, Pandit Ji Mishra Marg, Near Krishna Heart
                Hospital, Santosh Nagar, Nirman Nagar, Brijlalpura, Jaipur,
                Rajasthan 302019
              </span>
            </p>
          </div>

        </div>
      </section>
</PageTransition>
      <Footer visible mode="normal" />
    </>
  );
}
